import {ElementRef, Injectable} from "@angular/core";
import {Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AudioMulticastService {
    public audioMediaSourceListener: Subject<ElementRef[]> = new Subject();
}
